var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"min-vh-100",attrs:{"align-h":"center","align-v":"center"}},[_c('b-col',{staticClass:"text-center"},[_c('h1',[_vm._v("Initializing...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }